import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text16 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {identifyMethodType, joinHomeRegistryNotes} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(joinHomeRegistryNotes) && identifyMethodType === 2 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.itemNumber)}>-   </span>
          <span className={styles.bold}>	הערות בנסח הרישום:</span>
          <span>{getBreakLinesTextShumaType3(joinHomeRegistryNotes)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text16;
